export const PUBLIC_ANALYTICS_CONSENT_COOKIE = 'flopinio_public_analytics_consent';
export const PUBLIC_ANALYTICS_ACCEPTED = 'accepted';
export const PUBLIC_ANALYTICS_DECLINED = 'declined';

export const readPublicAnalyticsConfig = (doc = document) => {
  const element = doc.getElementById('public-analytics-config');
  if (!element?.textContent) return { enabled: false };

  try {
    return JSON.parse(element.textContent);
  } catch {
    return { enabled: false };
  }
};

export const readPublicAnalyticsConsent = (doc = document) => {
  const match = doc.cookie
    .split(';')
    .map((entry) => entry.trim())
    .find((entry) => entry.startsWith(`${PUBLIC_ANALYTICS_CONSENT_COOKIE}=`));

  if (!match) return null;

  const value = decodeURIComponent(match.split('=').slice(1).join('='));
  return [PUBLIC_ANALYTICS_ACCEPTED, PUBLIC_ANALYTICS_DECLINED].includes(value) ? value : null;
};

export const writePublicAnalyticsConsent = (value, doc = document) => {
  const secure = doc.location?.protocol === 'https:' ? '; Secure' : '';
  doc.cookie = `${PUBLIC_ANALYTICS_CONSENT_COOKIE}=${encodeURIComponent(value)}; Max-Age=15552000; Path=/; SameSite=Lax${secure}`;
};

export const setPublicAnalyticsBannerVisible = (banner, visible) => {
  if (!banner) return;

  banner.classList.toggle('hidden', !visible);
};
